/**
 * Orders tab for an org the server says can't have Order Flow Intelligence
 * yet (`GET /orders/v1/availability`, utils/ordersDailySupport.ts). Shows the
 * server's reason plainly instead of an older dashboard.
 */

import { Package } from 'lucide-react';

export default function OrdersComingSoon({ message }: { message: string }) {
  return (
    <div
      data-testid="orders-coming-soon"
      className="rounded-xl bg-card/60 border border-border/50 p-8 text-center"
    >
      <Package className="w-10 h-10 text-chart-5 mx-auto mb-4" aria-hidden="true" />
      <h3 className="text-lg font-semibold text-foreground mb-2">Not available yet</h3>
      <p className="text-base text-muted-foreground max-w-xl mx-auto">{message}</p>
    </div>
  );
}
